export default class File {
    constructor(blob) {
        // TODO: может быть генерировать id?
        // Это бы пригодилось для key в React
        this.blob = blob;
        this.uri = null;
        // Поле для обозначения файла, как не прошедшего валидацию.
        // Это решение перенесено из Сторибука, см. @avtopro/files-uploader
        this.error = false;
    }

    get size() {
        const { blob } = this;
        return blob ? blob.size : 0;
    }

    get type() {
        const { blob } = this;
        return blob ? blob.type : '';
    }

    get name() {
        const { blob, uri } = this;
        return ((blob ? blob.name : uri) || '').split('/').reverse()[0];
    }

    /**
     * Расширение файла ("png", "pdf", "doc", ...)
     */
    get extension() {
        const { blob, uri } = this;
        return ((blob ? blob.name : uri) || '').split(/.*\./)[1];
    }

    /**
     * MIME-тип файла, разбитый на части по разделителю "/".
     * Первая часть - базовый тип данных ("image", "application", ...)
     * Вторая часть - внутренний формат файла ("xml", "png", "pdf", ...)
     */
    get mime() {
        return this.type.split('/');
    }

    createUri() {
        this.revokeUri();
        if (this.blob) {
            try {
                this.uri = window.URL.createObjectURL(this.blob);
            } catch {
                this.uri = null;
            }
        }
        return this.uri;
    }

    revokeUri() {
        if (this.uri && this.blob) {
            try {
                window.URL.revokeObjectURL(this.uri);
            } catch (e) {
                console.warn(e);
            } finally {
                this.uri = null;
            }
        }
    }

    toString() {
        return this.name;
    }
}
